<template>
  <v-container fluid>
    <v-col class="col">
      <v-row class="child-flex">
        <email-templates-list> </email-templates-list>
      </v-row>
      <v-row class="child-flex">
        <email-templates-list show-templates-only class="mt-6">
        </email-templates-list>
      </v-row>
    </v-col>

    <v-speed-dial
      fixed
      bottom
      right
      transition="scale-transition"
      direction="top"
      v-model="templateFab"
    >
      <template v-slot:activator>
        <v-btn v-model="templateFab" color="blue darken-2" dark fab>
          <v-icon v-if="templateFab">mdi-close</v-icon>
          <v-icon v-else>mdi-plus</v-icon>
        </v-btn>
      </template>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn fab dark color="cyan" @click="handleNew('BeeFreeEmailTemplate')" v-on="on">
             <v-icon>mdi-plus</v-icon>
             <v-icon>mdi-cog</v-icon>
          </v-btn>
        </template>
        <span>
          New template with BeeFree Editor
        </span>
      </v-tooltip>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn fab dark color="teal" @click="handleNew('CustomEmailTemplate')" v-on="on">
             <v-icon>mdi-plus</v-icon>
             <v-icon>mdi-palette</v-icon>
          </v-btn>
        </template>
        <span>
          New template with HTML/Custom Editor
        </span>
      </v-tooltip>
    </v-speed-dial>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import EmailTemplatesList from './EmailTemplatesList'

export default {
  name: 'email-builder-index',
  components: {
    [EmailTemplatesList.name]: EmailTemplatesList
  },
  data: function () {
    return {
      templateFab: false
    }
  },
  computed: {
    ...mapState('DealerStore', ['dealer'])
  },
  methods: {
    handleNew (templateType) {
      this.$router.push({
        name: 'new_email_builder_path',
        query: { dealer_id: this.dealer.id, type: templateType }
      })
    }
  }
}
</script>

<style></style>
